import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { hasSupabaseConfig, publicEnv } from "../config/env";

let browserClient: SupabaseClient | null = null;
let persistAuthSession = true;

const authStorage = {
  getItem(key: string) {
    const sessionValue = window.sessionStorage.getItem(key);
    if (sessionValue !== null) {
      persistAuthSession = false;
      return sessionValue;
    }

    const localValue = window.localStorage.getItem(key);
    if (localValue !== null) {
      persistAuthSession = true;
    }
    return localValue;
  },
  setItem(key: string, value: string) {
    const primaryStorage = persistAuthSession ? window.localStorage : window.sessionStorage;
    const secondaryStorage = persistAuthSession ? window.sessionStorage : window.localStorage;
    primaryStorage.setItem(key, value);
    secondaryStorage.removeItem(key);
  },
  removeItem(key: string) {
    window.localStorage.removeItem(key);
    window.sessionStorage.removeItem(key);
  }
};

export function setAuthSessionPersistence(keepSignedIn: boolean) {
  persistAuthSession = keepSignedIn;
}

export function getSupabaseClient() {
  if (!hasSupabaseConfig()) {
    return null;
  }

  if (!browserClient) {
    browserClient = createClient(publicEnv.supabaseUrl, publicEnv.supabasePublishableKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storage: authStorage
      }
    });
  }

  return browserClient;
}
